import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';

/**
 * GetDescriptionArgs
 */
interface GetDescriptionArgs {
  /** 特集ジョブのタイトル */
  title: TopicJob['title'];
  /** 現在のページ番号 */
  currentPage: number;
  /** 表示開始件数 */
  fromCount: number;
  /** 表示終了件数 */
  toCount: number;
}

/**
 * 特集ページの説明文を生成する関数
 *
 * @param {GetDescriptionArgs} args - 説明文生成に必要な引数
 * @returns {string} - 生成された説明文
 */
export const getDescription = ({
  title,
  currentPage,
  fromCount,
  toCount,
}: GetDescriptionArgs) => {
  const pageInfo = `${currentPage}ページ目（${fromCount}-${toCount}件）の情報`;

  if (title) {
    if (currentPage >= 2) {
      return `${pageInfo}。${title}。転職・求人情報の検索ならdoda（デューダ）。`;
    }

    return `${title}。転職・求人情報の検索ならdoda（デューダ）。`;
  }

  if (currentPage >= 2) {
    return `${pageInfo}。求人特集の検索結果${currentPage}ページ目（${fromCount}-${toCount}件）の情報を掲載。`;
  }

  return `求人特集の転職・求人情報ページ。パーソルキャリアが運営する転職サイトのdoda（デューダ）では、大手・優良企業を中心に豊富な求人情報を掲載中。エージェントサービスでは、キャリアアドバイザーが、非公開求人のご紹介など、あなたの転職を成功に導くお手伝いをします。`;
};
